import { Patient } from "src/common/models/patient"
import { SelectionSearch } from "./SelectionSearch"
import { InputSearch } from "./InputSearch"

export enum PatientSearchMode {
    SELECTION = "SELECTION",
    INPUT = "INPUT"
}

interface Props {
    searchMode?: PatientSearchMode
    onPatientChange: (patient?: Patient) => void
}

export const SearchSection = ({
    searchMode = PatientSearchMode.INPUT,
    onPatientChange,
}: Props) => {
    return (
        searchMode === PatientSearchMode.SELECTION
            ? <SelectionSearch onPatientChange={onPatientChange} />
            : <InputSearch onPatientChange={onPatientChange} />
    )
}
